<!-- 个人信息 -->
<template>
  <div></div>
</template>

<script>
export default {
  name: 'Person',
  data() {
    return {}
  },
}
</script>

<style></style>
